module.exports = __webpack_public_path__ + "static/media/02-05.b1d4210e.png";